// extracted by mini-css-extract-plugin
export default {"biomeExample":"_3-HabitatDescription_biomeExample__bQPaT","fastFacts":"_3-HabitatDescription_fastFacts__SkrsS","center":"_3-HabitatDescription_center__bOA1u"};